import { MAX_WIDTH } from "@/utils/constant";
import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { ColorConf } from "../../config/color";
import AuthButtons from "./AuthButtons";
import Image from "next/image";
import { useWindowSize } from "usehooks-ts";

const ImageContainer2 = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  height: "100%",
  marginRight: "auto",
  marginLeft: "auto",
  maxWidth: MAX_WIDTH
}));

const HeaderText = styled(Typography)({
  fontSize: 23,
  lineHeight: "28px",
  fontWeight: 600,
  "@media (min-width: 600px)": {
    fontSize: 36,
    lineHeight: "44px",
  }
});
const HeaderHeart = styled("img")({
  width: 94,
  height: 84,
  position: "absolute",
  top: 160,
  right: 15,
  "@media (min-width: 600px)": {
    width: 152,
    height: 134,
    top: 200,
  }
});
const HeaderLine = styled("img")({
  width: 255,
  height: 35,
  position: "absolute",
  bottom: -30,
  left: -20,
  "@media (min-width: 600px)": {
    width: 396,
    height: 47,
    bottom: -40,
    left: -15,
  }
});

const Header = () => {
  const { width } = useWindowSize();

  const imageWidth = Math.min(Math.max(390, width), 744)
  const imageHeight = imageWidth * 1.2;

  return (
    <ImageContainer2>
      <Image
        src="/images/hero.avif"
        alt="hero"
        height={imageHeight}
        width={imageWidth}
        priority
      />
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          position: "absolute",
          top: {
            xs: 30,
            md: 50
          },
        }}
      >
        <HeaderText>
          あなたの <span style={{ color: ColorConf.HeroPrimaryColor, fontWeight: 700 }}>「したい」</span>を叶える
        </HeaderText>
        <HeaderText>
          <span style={{ color: ColorConf.HeroPrimaryColor, fontWeight: 700 }}>女性のためのマッチング</span>サービス
        </HeaderText>
        <HeaderLine src="/images/hero-line2.avif" alt="line2" />
      </Stack>
      <HeaderHeart src="/images/hero-heart2.avif" alt="heart2" />
      <AuthButtons />
    </ImageContainer2>
  );
};

export default Header;